export default "__VITE_ASSET__DPQuF4Nn__"